import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Table,
  Tag,
  Typography,
} from "antd";
import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import Spinner from "../../../../../common/spinner/Spinner";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
import {
  getServiceProviderServicesAction,
  updateOrganizationServicesStatusAction,
} from "../../../../../../redux/services/service-providers/serviceProvidersServices";
import { colors } from "../../../../../../constants/colors";
import { dateObjToDispViewDate } from "../../../../../../utils/utils";
import { CustomTitle } from "../../../../../common/customTitle";

const ServicesDialog = ({ open, onClose }) => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* id dependencies */
  const { selectedOrganizationId, serviceProviderServices } = useSelector(
    (state) => state.serviceProviders
  );
  /* id dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: serviceProviderServices?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  /* table dependencies */

  useEffect(() => {
    handleGetTableData();
  }, [open, pagination]);

  const handleGetTableData = () => {
    /* initial dependencies - Edit */
    if (
      selectedOrganizationId &&
      selectedOrganizationId !== "" &&
      selectedOrganizationId !== null &&
      selectedOrganizationId !== undefined
    ) {
      const dataToBeSent = {
        page: pagination?.pageNo,
        limit: pagination?.pageSize,
        selectedOrganizationId,
      };
      setLoading(true);
      dispatch(getServiceProviderServicesAction(dataToBeSent, setLoading));
    }
    /* initial dependencies - Edit */
  };

  /* dialog close dependencies */
  const handleDialogClose = () => {
    onClose();
    form.resetFields();
  };
  /* dialog close dependencies */

  /* on status changed */
  const onStatusChanged = (id, value, record) => {
    const dataToBeSent = {};
    dataToBeSent.selectedOrganizationId = record?._id;
    dataToBeSent["is_active"] = value?.value === "active" ? true : false;

    dispatch(
      updateOrganizationServicesStatusAction(dataToBeSent, setLoading)
    ).then(() => {
      handleGetTableData();
    });
  };
  /* on status changed */

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("appointmentInfo.dateOfJoining"),
        dataIndex: "created_at",
        key: "created_at",
        render: (_, record) => (
          <p>{dateObjToDispViewDate(record?.created_at, "ddmmyyyy")}</p>
        ),
      },
      {
        title: t("appointmentInfo.service"),
        dataIndex: "title",
        key: "title",
      },
      {
        title: t("appointmentInfo.category"),
        dataIndex: "category",
        key: "category",
        render: (_, record) => `${record?.categoryInfo?.category?.name || "-"}`,
      },
      {
        title: t("appointmentInfo.subCategory"),
        dataIndex: "subcategory",
        key: "subcategory",
        render: (_, record) => `${record?.categoryInfo?.subcategory?.name || "-"}`,
      },
      {
        title: t("appointmentInfo.status"),
        key: "action",
        align: "center",
        render: (_, record) => {
          const getColorBasedOnStatus = (status) => {
            switch (status) {
              case "active":
                return { background: colors.lightTeal, color: colors.darkTeal };

              case "inactive":
                return {
                  background: colors.lightPinkishRed,
                  color: colors.darkMaroon,
                };

              default:
                break;
            }
          };
          const is_active = record?.is_active ? "active" : "inactive";

          return (
            <>
              <Tag
                bordered={false}
                style={{
                  ...getColorBasedOnStatus(is_active),
                  textTransform: "capitalize",
                }}
              >
                {is_active}
              </Tag>
            </>
          );
        },
      },
      {
        title: t("appointmentInfo.action"),
        key: "action",
        align: "center",
        render: (_, record) => {
          const is_active = record?.is_active ? "active" : "inactive";
          return (
            <>
              <Select
                options={[
                  { value: "active", label: t("CommonUtils.active")},
                  { value: "inactive", label: t("CommonUtils.inactive")},
                ]}
                placeholder="Select Status"
                defaultValue={is_active}
                style={{ width: 120 }}
                onChange={(id, value) => onStatusChanged(id, value, record)}
              />
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, [serviceProviderServices]);
  /* initial dependencies rendering */

  return (
    <Modal
      open={open}
      onCancel={handleDialogClose}
      footer={false}
      confirmLoading={loading}
      style={{ top: 20 }}
      width={1000}
    >
      <Flex gap="1rem" vertical>
        <CustomTitle textDecoration="underline" justifyContent="center">
          {t("Modules.Provider.services")}
        </CustomTitle>
        {loading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={serviceProviderServices?.data}
            columns={columns}
            pagination={paginationObj}
          />
        )}
      </Flex>
    </Modal>
  );
};

export default ServicesDialog;
